import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { DriverLocationWithInfo } from "@/interface/location";

const LOCATION_QUERY_KEY = "driver-location";

/**
 * 모든 기사의 위치 + 정보 조회 (관제 시스템용)
 * 30초마다 자동 갱신
 */
export const useDriverLocationControl = (enabled: boolean = true) => {
  return useQuery<DriverLocationWithInfo[]>({
    queryKey: [LOCATION_QUERY_KEY, "control"],
    queryFn: async () => {
      const response = await api.get<{ data: DriverLocationWithInfo[] }>("/driver-location/control");
      return response.data;
    },
    enabled,
    refetchInterval: 30000, // 30초마다 자동 갱신
    refetchIntervalInBackground: false, // 백그라운드에서는 갱신 안 함
    staleTime: 25000, // 25초 동안은 신선한 데이터로 간주
  });
};
